module.exports = __webpack_public_path__ + "static/media/playstore-3b.ae908c6c.png";